import { z } from "zod";
import { zCommonResponse } from "./common.schemas";

export const zManualMembershipUpdateRequestBody = z.object({
	paymentAction: z.enum(["renew", "new", "none"]),
	activeUntil: z.string().nullable().optional(), // Expecting ISO string or similar from frontend
});

export const zManualMembershipUpdateResponse = zCommonResponse;

export const zManualMembershipUpdatePathParams = z.object({
	memberId: z.coerce.number(),
});

